import React from "react";

export default function({iconComp,text,onClick,type,disabled}) {
  return (
    <div class={`${disabled ? "initial-slack-teams-btn-disabled" :"initial-slack-teams-btn cursor-pointer" }`}  onClick={disabled ? null : onClick}>
      <div class={type==="SLACK"?"initial-slack-icon-wrapper":"initial-teams-icon-wrapper"}>
        {iconComp}
      </div>
      <div class={type==="SLACK"?"initial-slack-btn-text":"initial-teams-btn-text"}>
        <b>{text}</b>
      </div>
    </div>
  );
}
